export enum WizardActionDestination {
	WIZARD_ONLINE = 'wizard_online',
	HOMEPAGE = 'homepage',
	MEASUREMENT_HISTORY = 'measurementHistory',
	CREATE_CASE = 'createCase',
	BROWSER = 'browser',
	JOB_WAITING = 'jobWaiting',
}
